import { render, staticRenderFns } from "./FormSectionInfo.vue?vue&type=template&id=61cafecc&scoped=true"
import script from "./FormSectionInfo.vue?vue&type=script&lang=js"
export * from "./FormSectionInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cafecc",
  null
  
)

export default component.exports